import { Component, inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { StreamClosingResult, StreamClosingType } from '../../../../../lib/interfaces/generic-streams';

@Component({
    selector: 'app-add-sream-result',
    standalone: false,
    templateUrl: './add-sream-result.component.html',
    styleUrl: './add-sream-result.component.scss'
})
export class AddSreamResultComponent implements OnInit {

    private data = inject(MAT_DIALOG_DATA);
    private dialogRef = inject(MatDialogRef<AddSreamResultComponent>);

    public title: string = this.data.title;
    public resultTitle: string = this.data.value ? this.data.value.title : ""
    public closingPromptId: string = this.data.value ? this.data.value.type : ""
    public closingStreamTypes: StreamClosingType[] = this.data.closingStreamTypes;
    public editMode: boolean = this.data.edit;

    ngOnInit(): void {
    }

    onCancel() {
        this.dialogRef.close();
    }

    onSave() {
        let result: Partial<StreamClosingResult> = {
            title: this.resultTitle,
            type: this.closingPromptId
        }
        this.dialogRef.close(result);
    }

}
